<template>
    <v-row>
        <v-col class="px-3 py-0 pb-1" cols="12" sm="3" md="3">
            <b class="texts">Operadora:</b>
            <p class="texts mb-0">{{info.oper_nome}}</p>
        </v-col>

        <v-col class="px-3 py-0 pb-1" cols="12" sm="3" md="3">
            <b class="texts">Prestador:</b>
            <p class="texts mb-0">{{info.prest_nome}}</p>
        </v-col>

        <v-col class="px-3 py-0 pb-1" cols="12" sm="2" md="2">
            <b class="texts">Data de faturamento:</b>
            <p class="texts mb-0">{{info.dt_faturamento  | formatDate}}</p>
        </v-col>
        <v-col class="px-3 py-0 pb-1" cols="12" sm="2" md="2">
            <b class="texts">Data prev. de vcto:</b>
            <p class="texts mb-0">{{info.dt_prev_vencimento | formatDate}}</p>
        </v-col>
        <v-col class="px-3 py-0 pb-1" cols="12" sm="2" md="2">
            <b class="texts">Lotes:</b>
            <p class="texts mb-0">{{info.qt_arq}}</p>
        </v-col>
        <v-col cols="12">
            <v-divider></v-divider>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        info: Object
    }
}
</script>

<style>

</style>